'use client';

import dynamic from 'next/dynamic';
import { associatedPrograms } from './(primary)/mba-campus-immersion-online/pageJSON';
import footerData from "@/data/static-footer-data.json";
import Footer from "@organisms/Footer";
import {programsData} from "@/data/static-programs-data";
import ProgramList from '@/components/organisms/SimilarProgramsSection/ProgramList';
import headerListMenu from '@/data/program-menu-data.json';

const HeaderOpt = dynamic(() => import("@/components/organisms/HeaderOpt"));

/**
 * Error boundary UI — uses program-menu-data.json (same as slug error page)
 * instead of DropdownMenu.js (~98KB) so that heavy menu JS stays off the
 * main homepage client graph.
 */
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  const headerMenuList = headerListMenu;
   
  return (
    <>
        <HeaderOpt popularCourses={[]} newLaunches={[]} headerMenuList={headerMenuList} associatedPrograms={associatedPrograms} isMobile={false}/>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <h1>An unexpected error occurred. We’re investigating and will fix it shortly.</h1>
          <p> </p>
          <a href="/" style={{color : "blue"}}>Go to Home</a>
        </div>
        <div className='pl=[6.25rem] pr=[6.25rem] max-w-[85%] m-auto'>
        <ProgramList programs={programsData} />
        </div>
      <Footer footerData={footerData} />
    </>
  );
}
